// This is atemporary hack to prevent spinner modal from closing other modals

export const SpinnerToggle = {
  PREVENT_SPINNER: 'preventSpinner',
};
